(function ($) {
  $(function () {
    $(document).on('click', '.js-video-play', function () {
      const $wrapper = $(this).closest('.js-video');
      if (!$wrapper.length) return;

      const type = $wrapper.data('video-type');

      if (type === 'external') {
        const url = $wrapper.data('video-url');
        const embedUrl = buildEmbedUrl(url);
        if (!embedUrl) return;

        $wrapper.html(
          `<iframe src="${embedUrl}"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
            loading="lazy"></iframe>`
        );
      } else {
        const src = $wrapper.data('video-src');
        $wrapper.html(
          `<video src="${src}" controls autoplay playsinline></video>`
        );
      }
    });

    function buildEmbedUrl(url) {
      if (!url) return null;

      const ytMatch = url.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/
      );
      if (ytMatch) {
        return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&rel=0`;
      }

      const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vimeoMatch) {
        return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
      }

      return null;
    }
  });
})(jQuery);
